import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DashboardHeader } from '../components/DashboardHeader';
import { XCircle, ArrowLeft } from 'lucide-react';

const BillingCancel: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <DashboardHeader title="Payment Cancelled" isDashboardPage={true} />
      
      <main className="container max-w-screen-xl mx-auto px-4 pt-24 pb-12">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200/50 dark:border-gray-700/50 p-8 max-w-2xl mx-auto text-center">
          <div className="flex justify-center mb-6">
            <XCircle className="h-16 w-16 text-red-500" />
          </div>
          
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">
            Payment Cancelled
          </h1>
          
          <p className="text-gray-600 dark:text-gray-400 mb-6">
            Your payment was cancelled and you have not been charged.
          </p>
          
          <div className="flex justify-center">
            <button
              onClick={() => navigate('/billing')}
              className="flex items-center bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-4 rounded-md transition-colors"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Return to Billing
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default BillingCancel;
